import { Button, Divider } from 'antd';
import SuccessImg from '../../assets/images/SuccessImg.svg';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearRequest } from '../../redux/requestSlice';
import { clearBank } from '../../redux/providerSlice';
import { StorageService } from '../../services/Storage';
import { IRootState } from '../../redux/store';
import { selectFlowStep } from '../../redux/headerSlice';
import { REDIRECTION_URL } from '../../utils/constants';
import { EventMessageService } from '../../services/EventMessage';
import { isLoading } from '../../redux/loaderSlice';
import InsightService from '../../services/Insight';

export const Success = () => {
  const dispatch = useDispatch();
  const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);

  const handleSuccess = () => {
    pepperOne && EventMessageService.sendMessageEvent('success');
  }

  const clearStoredData = async () => {
    InsightService.logTrace('Success', [
      { Success: true },
    ]);
    dispatch(clearRequest());
    dispatch(clearBank());
    StorageService.deleteStorage();
  }

  useEffect(() => {
    dispatch(selectFlowStep(null));
    clearStoredData();
    dispatch(isLoading(false));
  }, [])

  return (
    <div className='pepper-status-page pepper-page-padding'>
      <img className='success-img' src={SuccessImg} alt='pepper-success' />
      <div className='pepper-status-text-body'>
        <div className='pepper-title-center'>Completado con éxito.</div>
        <div className='pepper-subtitle'>¡Genial! El proceso se ha finalizado correctamente.</div>
      </div>
      <Divider className='success-divider' />
      <p>Gracias por confiar en Pepper.</p>
      {pepperOne ? <Button type="primary" shape="round" onClick={handleSuccess}>Continuar</Button> : <a href={REDIRECTION_URL} target='_self' className='pepper-link'>www.pepperfinance.es</a>}
    </div>
  )
}